module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig03_measured-profile.ee23caac.png";